import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import Modal from './Modal';

var ConfirmModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfirmModal, _React$Component);

  function ConfirmModal(props) {
    var _this;

    _classCallCheck(this, ConfirmModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfirmModal).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isVisible: false,
      actions: null
    });

    _this._hideModal = _this._hideModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._showModal = _this._showModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._confirm = _this._confirm.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._onClickConfirm = _this._onClickConfirm.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._onClickCancel = _this._onClickCancel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ConfirmModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          enhance = _this$props.enhance,
          children = _this$props.children;
      var isVisible = this.state.isVisible;
      return React.createElement(Fragment, null, enhance(this._confirm), React.createElement(Modal, {
        isVisible: isVisible,
        onClickOverlay: this._onClickCancel
      }, children(this._onClickConfirm, this._onClickCancel)));
    }
  }, {
    key: "_hideModal",
    value: function _hideModal() {
      this.setState({
        isVisible: false,
        actions: null
      });
    }
  }, {
    key: "_showModal",
    value: function _showModal(actions) {
      this.setState({
        isVisible: true,
        actions: actions
      });
    }
  }, {
    key: "_confirm",
    value: function _confirm(callback) {
      var _this2 = this;

      return new Promise(function (_resolve, _reject) {
        _this2._showModal({
          resolve: function resolve(confirmed) {
            _resolve(confirmed);

            _this2._hideModal();
          },
          reject: function reject() {
            _reject();

            _this2._hideModal();
          }
        });
      });
    }
  }, {
    key: "_onClickConfirm",
    value: function _onClickConfirm() {
      var actions = this.state.actions;
      actions.resolve(true);
    }
  }, {
    key: "_onClickCancel",
    value: function _onClickCancel() {
      var actions = this.state.actions;
      actions.resolve(false);
    }
  }]);

  return ConfirmModal;
}(React.Component);

export default ConfirmModal;